<template>
  <div class="">
    <PageHeader :items="items" />
    <div class="row">
      <div
        v-if="$can('backoffice-document-assignment.list')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/document-assignment">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">{{ $t("documentAssignment") }}</p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('backoffice-mail-template-assignment.list')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/mail-template-assignment">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">
              {{ $t("mailTemplateAssignment") }}
            </p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('backoffice-invoice-reminder-level.list')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/invoice-reminder-levels">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">{{ $t("reminderLevels") }}</p>
          </div>
        </router-link>
      </div>

      <div
        v-if="$can('list-permissions')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/permissions">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">{{ $t("permissions") }}</p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('list-roles')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/roles">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'RolesNIcon'" />
            <p class="setting-card-text">{{ $t("roles") }}</p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('list-api-tokens')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/api-keys">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'apiKeyNIcon'" />
            <p class="setting-card-text">{{ $t("apiKeys") }}</p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('backoffice-mail-template.list')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/mail-templates">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">
              {{ $t("mailTemplates") }}
            </p>
          </div>
        </router-link>
      </div>
      <div
        v-if="$can('backoffice-document-template.list')"
        class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
      >
        <router-link to="/document-templates">
          <div class="setting-card-container">
            <ElementIcon v-bind:icon="'permissionNIcon'" />
            <p class="setting-card-text">
              {{ $t("documentTemplates") }}
            </p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ElementIcon from "@/components/elements/Icon.vue";
import { BTabs, BTab } from "bootstrap-vue";
import PageHeader from "@/components/PageHeader.vue";
export default {
  components: {
    BTabs,
    BTab,
    ElementIcon,
    PageHeader,
  },
  computed: {
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("settings"),
          active: true,
        },
      ];
    },
  },
};
</script>
<style lang="scss">
.setting-card-container {
  border: 1px solid rgba(17, 37, 62, 0.2);
  background: #fff;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);

  height: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
  gap: 10px;
  margin-bottom: 20px;
  padding: 17px 30px;

  &:hover {
    border: 1px solid #38414a;
  }
}

// .setting-card-container:hover {
//   background-color: #38414a;
// }

// .setting-card-container:hover i {
//     color: white;
// }

// .setting-card-container:hover .setting-card-text {
//     color: white;
// }

.setting-card-text {
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
}
</style>
